/* product.js — page produit « Tiitoune Aurum » (T15).
   Galerie (vignettes + swap de média), résolution de variante (pilules radio
   + select de la barre collante, synchronisés dans les deux sens), re-rendu
   du prix par la Section Rendering API, disponibilité (libellés des boutons),
   stepper de quantité, zoom au survol (origine suivie au pointeur), barre
   d'achat collante (IntersectionObserver), partage (Web Share API, repli
   copie de lien) et recommandations produits (fetch + swap).
   L'AJOUT AU PANIER n'est pas géré ici : cart.js intercepte le submit de
   form[data-cart-add-form] par délégation sur document.
   Idempotent : init par racine via un drapeau dataset ; sur
   shopify:section:load la section est re-rendue (nœuds neufs, drapeau vierge),
   les anciens écouteurs partent avec les anciens nœuds. */
(function () {
  'use strict';

  /* Garde anti double-exécution (éditeur de thème, scripts dupliqués) */
  if (window.__aurumProduct) return;
  window.__aurumProduct = true;

  function noop() {}

  /* Re-scan des [data-reveal] injectés (recommandations) */
  function engineRefresh(root) {
    if (window.AurumEngine && typeof window.AurumEngine.refresh === 'function') {
      window.AurumEngine.refresh(root);
    }
  }

  /* ==================================================================
     Page produit — une init par racine [data-product-root]
     ================================================================== */
  function initProduct(root) {
    if (root.dataset.productInit === '1') return;
    root.dataset.productInit = '1';

    var sectionId = root.getAttribute('data-section-id');
    var productUrl = root.getAttribute('data-product-url');

    /* Variantes (JSON Liquid) — absent si variante unique par défaut */
    var variants = [];
    var variantScript = root.querySelector('[data-variant-json]');
    if (variantScript) {
      try {
        variants = JSON.parse(variantScript.textContent);
      } catch (error) {
        variants = [];
      }
    }

    var variantInput = root.querySelector('[data-variant-input]');
    var addButton = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var stickyBar = root.querySelector('[data-sticky-bar]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var stickyAddLabel = root.querySelector('[data-sticky-add-label]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickySelect = root.querySelector('[data-sticky-variant-select]');
    var priceWrapper = root.querySelector('[data-price-wrapper]');

    /* ----------------------------------------------------------------
       Galerie — activation d'un média (visionneuse + vignettes)
       ---------------------------------------------------------------- */
    function setMedia(mediaId) {
      if (!mediaId) return;
      var items = root.querySelectorAll('[data-main-media] [data-media-id]');
      var found = false;
      Array.prototype.forEach.call(items, function (item) {
        if (item.getAttribute('data-media-id') === String(mediaId)) found = true;
      });
      if (!found) return; /* média inconnu : on ne touche à rien */

      Array.prototype.forEach.call(items, function (item) {
        var active = item.getAttribute('data-media-id') === String(mediaId);
        if (active) {
          item.removeAttribute('hidden');
        } else {
          item.setAttribute('hidden', '');
          /* Une vidéo masquée ne doit pas continuer à jouer */
          var video = item.querySelector('video');
          if (video && !video.paused) video.pause();
        }
      });

      var activeThumb = null;
      Array.prototype.forEach.call(root.querySelectorAll('[data-thumbs] [data-media-id]'), function (thumb) {
        var active = thumb.getAttribute('data-media-id') === String(mediaId);
        thumb.classList.toggle('is-active', active);
        if (active) {
          thumb.setAttribute('aria-current', 'true');
          activeThumb = thumb;
        } else {
          thumb.removeAttribute('aria-current');
        }
      });

      /* Défilement du rail de vignettes UNIQUEMENT — jamais la page
         (scrollIntoView ferait défiler tous les ancêtres). On centre la
         vignette active dans le rail, sur l'axe où il déborde réellement
         (horizontal en mobile, vertical ≥990px). */
      var rail = root.querySelector('[data-thumbs]');
      if (rail && activeThumb) {
        var railRect = rail.getBoundingClientRect();
        var thumbRect = activeThumb.getBoundingClientRect();
        if (rail.scrollWidth > rail.clientWidth) {
          rail.scrollLeft += thumbRect.left - railRect.left - (railRect.width - thumbRect.width) / 2;
        }
        if (rail.scrollHeight > rail.clientHeight) {
          rail.scrollTop += thumbRect.top - railRect.top - (railRect.height - thumbRect.height) / 2;
        }
      }
    }

    /* ----------------------------------------------------------------
       Disponibilité — libellés et état des boutons d'achat.
       state : 'available' | 'soldout' | 'unavailable'
       ---------------------------------------------------------------- */
    function setAvailability(state) {
      if (!addButton) return;
      var label;
      if (state === 'available') {
        label = addButton.getAttribute('data-label-add');
      } else if (state === 'soldout') {
        label = addButton.getAttribute('data-label-soldout');
      } else {
        label = addButton.getAttribute('data-label-unavailable');
      }
      var off = state !== 'available';

      /* data-keep-disabled : interdit à cart.js de ré-activer un bouton
         que la disponibilité a verrouillé (voir onAddSubmit côté cart.js) */
      addButton.disabled = off;
      if (off) {
        addButton.setAttribute('data-keep-disabled', '');
      } else {
        addButton.removeAttribute('data-keep-disabled');
      }
      if (addLabel && label) addLabel.textContent = label;
      if (stickyAdd) {
        stickyAdd.disabled = off;
        if (off) {
          stickyAdd.setAttribute('data-keep-disabled', '');
        } else {
          stickyAdd.removeAttribute('data-keep-disabled');
        }
      }
      if (stickyAddLabel && label) stickyAddLabel.textContent = label;

      /* Paiement accéléré (Shop Pay, etc.) — doit suivre la disponibilité :
         masqué + clics neutralisés hors 'available', sinon le bouton
         achèterait la dernière variante valide. Requêté à chaque appel car
         le SDK Shopify peut injecter le bouton après l'init. */
      var paymentButton = root.querySelector('.shopify-payment-button');
      if (paymentButton) {
        paymentButton.hidden = off;
        paymentButton.style.pointerEvents = off ? 'none' : '';
      }
    }

    /* ----------------------------------------------------------------
       Prix — re-rendu par la Section Rendering API (formatage monétaire
       garanti par Liquid). Jeton anti-course : seule la dernière requête
       écrit dans le DOM.
       ---------------------------------------------------------------- */
    var priceToken = 0;

    function refreshPrice(variantId) {
      if (!priceWrapper || !productUrl || !sectionId) return;
      priceToken += 1;
      var token = priceToken;

      fetch(productUrl + '?variant=' + variantId + '&section_id=' + sectionId)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          if (token !== priceToken) return; /* réponse périmée */
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshPrice = doc.getElementById('price-' + sectionId);
          if (freshPrice) priceWrapper.innerHTML = freshPrice.innerHTML;
          var freshSticky = doc.querySelector('[data-sticky-price]');
          if (freshSticky && stickyPrice) stickyPrice.textContent = freshSticky.textContent;
        })
        .catch(function () {
          /* Repli hors-ligne : formatage client depuis le JSON des variantes
             (moins fidèle que Liquid, mais jamais un prix périmé affiché).
             Devise lue sur <html data-currency> (posée par theme.liquid). */
          if (token !== priceToken) return;
          var variant = findVariantById(variantId);
          if (!variant || typeof variant.price !== 'number') return;
          var formatted = (variant.price / 100).toLocaleString('fr-FR', {
            style: 'currency',
            currency: document.documentElement.getAttribute('data-currency') || 'EUR'
          });
          var current = priceWrapper.querySelector('.price__current');
          if (current) {
            current.textContent = formatted;
          } else {
            priceWrapper.textContent = formatted;
          }
          if (stickyPrice) stickyPrice.textContent = formatted;
        });
    }

    /* ----------------------------------------------------------------
       Résolution de variante depuis les pilules radio
       ---------------------------------------------------------------- */
    function getSelectedOptions() {
      var values = [];
      Array.prototype.forEach.call(root.querySelectorAll('[data-option-position]'), function (fieldset) {
        var position = parseInt(fieldset.getAttribute('data-option-position'), 10);
        var checked = fieldset.querySelector('input:checked');
        if (checked) values[position - 1] = checked.value;
      });
      return values;
    }

    function findVariant(options) {
      for (var i = 0; i < variants.length; i += 1) {
        var match = true;
        for (var j = 0; j < options.length; j += 1) {
          if (variants[i].options[j] !== options[j]) {
            match = false;
            break;
          }
        }
        if (match) return variants[i];
      }
      return null;
    }

    /* Applique une variante : champ caché, URL, média, dispo, prix, select */
    function applyVariant(variant) {
      if (!variant) {
        /* Combinaison irrésoluble : on vide l'id caché pour qu'un submit
           (natif ou AJAX) ne parte JAMAIS avec la variante précédente —
           id vide → /cart/add échoue bruyamment (422 affiché par cart.js). */
        if (variantInput) variantInput.value = '';
        setAvailability('unavailable');
        markUnavailablePills();
        return;
      }
      if (variantInput) variantInput.value = variant.id;

      /* URL partageable, sans rechargement ni entrée d'historique */
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', productUrl + '?variant=' + variant.id);
      }

      if (variant.featured_media && variant.featured_media.id) {
        setMedia(variant.featured_media.id);
      }

      setAvailability(variant.available ? 'available' : 'soldout');
      refreshPrice(variant.id);

      if (stickySelect && stickySelect.value !== String(variant.id)) {
        stickySelect.value = String(variant.id);
      }

      markUnavailablePills();
    }

    /* ----------------------------------------------------------------
       Pilules indisponibles — pour chaque valeur V à la position P, la
       pilule est « disponible » si AU MOINS une variante combinant V et
       les AUTRES options actuellement sélectionnées est disponible.
       Les pilules marquées restent cliquables (les sélectionner affiche
       l'état épuisé/indisponible — comportement standard Dawn).
       ---------------------------------------------------------------- */
    function markUnavailablePills() {
      if (!variants.length) return;
      var selected = getSelectedOptions();
      Array.prototype.forEach.call(root.querySelectorAll('[data-option-position]'), function (fieldset) {
        var position = parseInt(fieldset.getAttribute('data-option-position'), 10);
        Array.prototype.forEach.call(fieldset.querySelectorAll('input[data-option-value]'), function (input) {
          var candidate = selected.slice();
          candidate[position - 1] = input.value;
          var available = false;
          for (var i = 0; i < variants.length; i += 1) {
            var match = true;
            for (var j = 0; j < candidate.length; j += 1) {
              if (variants[i].options[j] !== candidate[j]) {
                match = false;
                break;
              }
            }
            if (match && variants[i].available) {
              available = true;
              break;
            }
          }
          var pill = fieldset.querySelector('label[for="' + input.id + '"]');
          if (pill) pill.classList.toggle('is-unavailable', !available);
        });
      });
    }

    /* Coche les pilules correspondant à une variante (sync select → radios) */
    function syncPills(variant) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-option-position]'), function (fieldset) {
        var position = parseInt(fieldset.getAttribute('data-option-position'), 10);
        var value = variant.options[position - 1];
        Array.prototype.forEach.call(fieldset.querySelectorAll('input'), function (input) {
          input.checked = input.value === value;
        });
      });
    }

    function findVariantById(id) {
      for (var i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    /* ----------------------------------------------------------------
       Écouteurs — délégation à l'intérieur de la racine de section
       ---------------------------------------------------------------- */
    root.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      /* Pilule de variante */
      if (target.closest('[data-option-value]')) {
        applyVariant(findVariant(getSelectedOptions()));
        return;
      }

      /* Select de la barre collante → synchronise les pilules */
      if (target.closest('[data-sticky-variant-select]')) {
        var variant = findVariantById(target.value);
        if (variant) {
          syncPills(variant);
          applyVariant(variant);
        }
        return;
      }

      /* Saisie directe de quantité — garde min 1, entier */
      var qtyInput = target.closest('[data-qty-input]');
      if (qtyInput) {
        var parsed = parseInt(qtyInput.value, 10);
        if (isNaN(parsed) || parsed < 1) parsed = 1;
        qtyInput.value = parsed;
      }
    });

    root.addEventListener('click', function (event) {
      /* Vignettes de la galerie */
      var thumb = event.target.closest('[data-thumbs] [data-media-id]');
      if (thumb && root.contains(thumb)) {
        setMedia(thumb.getAttribute('data-media-id'));
        return;
      }

      /* Stepper de quantité */
      var minus = event.target.closest('[data-qty-minus]');
      var plus = event.target.closest('[data-qty-plus]');
      if (minus || plus) {
        var stepper = (minus || plus).closest('[data-qty-stepper]');
        var input = stepper && stepper.querySelector('[data-qty-input]');
        if (!input) return;
        var current = parseInt(input.value, 10);
        if (isNaN(current)) current = 1;
        input.value = Math.max(1, current + (plus ? 1 : -1));
        return;
      }

      /* Partage — Web Share API, sinon copie du lien */
      var shareBtn = event.target.closest('[data-share-button]');
      if (shareBtn) {
        var url = shareBtn.getAttribute('data-share-url') || window.location.href;
        var title = shareBtn.getAttribute('data-share-title') || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(noop);
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            var copied = shareBtn.getAttribute('data-label-copied');
            var labelNode = shareBtn.querySelector('[data-share-label]');
            var status = root.querySelector('[data-share-status]');
            if (status && copied) status.textContent = copied;
            if (labelNode && copied) {
              var original = labelNode.textContent;
              labelNode.textContent = copied;
              shareBtn.classList.add('is-copied');
              window.setTimeout(function () {
                labelNode.textContent = original;
                shareBtn.classList.remove('is-copied');
                if (status) status.textContent = '';
              }, 2000);
            }
          }).catch(noop);
        }
      }
    });

    /* ----------------------------------------------------------------
       Zoom au survol — origine du scale suivie au pointeur (souris
       uniquement ; le scale lui-même est appliqué/limité en CSS).
       ---------------------------------------------------------------- */
    var viewer = root.querySelector('[data-main-media]');
    if (viewer) {
      viewer.addEventListener('pointermove', function (event) {
        if (event.pointerType !== 'mouse') return;
        var item = event.target.closest('.product__media-item--image');
        if (!item) return;
        var img = item.querySelector('img');
        if (!img) return;
        var rect = item.getBoundingClientRect();
        var x = ((event.clientX - rect.left) / rect.width) * 100;
        var y = ((event.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
        item.classList.add('is-zoomed');
      });
      viewer.addEventListener('pointerleave', function () {
        Array.prototype.forEach.call(viewer.querySelectorAll('.is-zoomed'), function (item) {
          item.classList.remove('is-zoomed');
        });
      });
      /* Sortie d'un média vers un autre à l'intérieur de la visionneuse */
      viewer.addEventListener('pointerout', function (event) {
        var item = event.target.closest('.product__media-item--image');
        if (item && (!event.relatedTarget || !item.contains(event.relatedTarget))) {
          item.classList.remove('is-zoomed');
        }
      });
    }

    /* ----------------------------------------------------------------
       Barre d'achat collante — visible dès que le bouton principal
       n'est PAS à l'écran (au-dessus OU en dessous) : le CTA reste
       atteignable en permanence, y compris à l'arrivée sur la page.
       ---------------------------------------------------------------- */
    if (stickyBar && addButton && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
      observer.observe(addButton);
    }

    /* État initial des pilules — marque d'emblée les combinaisons épuisées */
    markUnavailablePills();
  }

  /* ==================================================================
     Recommandations — fetch de la section re-rendue, swap de l'innerHTML
     ================================================================== */
  function initRecommendations(container) {
    if (container.dataset.recsLoaded === '1') return;
    container.dataset.recsLoaded = '1';
    var url = container.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim() !== '') {
          container.innerHTML = fresh.innerHTML;
          engineRefresh(container);
        }
      })
      .catch(noop);
  }

  /* ==================================================================
     Init — au chargement puis à chaque re-rendu de l'éditeur de thème
     ================================================================== */
  function initAll(scope) {
    var rootScope = scope || document;
    if (rootScope.querySelectorAll) {
      Array.prototype.forEach.call(rootScope.querySelectorAll('[data-product-root]'), initProduct);
      Array.prototype.forEach.call(rootScope.querySelectorAll('[data-recommendations]'), initRecommendations);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Éditeur de thème : section re-rendue → nœuds neufs, drapeaux vierges */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
